"use client";

import { Share2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { shareMessage } from "@/lib/native/share";

/**
 * A guest seat's "tell them" button. The ticket itself is emailed once the
 * booking is paid; this is the buyer's own heads-up, sent from their phone,
 * with a link to the event so the guest can see it (and join Hiive) before
 * the email lands.
 */
export function GuestSeatShare({
  guestName,
  guestEmail,
  eventName,
  dateLabel,
  eventPath,
}: {
  guestName: string;
  guestEmail: string;
  eventName: string;
  dateLabel: string;
  eventPath: string;
}) {
  const firstName = guestName.trim().split(/\s+/)[0] || guestName;

  const share = async () => {
    const url = `${window.location.origin}${eventPath}`;
    const text = `${firstName}, I got you a ticket to ${eventName} on ${dateLabel}. It'll be emailed to ${guestEmail}, just show the QR at the door. See the event and who's going on Hiive:`;
    const outcome = await shareMessage({ title: eventName, text, url });
    if (outcome === "copied")
      toast.success(`Message copied. Paste it to ${firstName}.`);
    if (outcome === "failed") toast.error("Couldn't share right now");
  };

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={() => void share()}
      className="mt-2 h-8 gap-1.5 rounded-full px-3 text-xs"
    >
      <Share2 className="size-3.5" aria-hidden="true" />
      Let {firstName} know
    </Button>
  );
}
